import {
  BulkApprovalAction,
  BulkApprovalCategory,
} from '~/scenes/MyWorkspace/components/Widgets/components/ApprovalWidget/data/index';
import { ApprovalWidgetData } from '~/scenes/MyWorkspace/components/Widgets/components/ApprovalWidget/types';
import { fetchFromNewApi } from '~/services/Http';

export const approveRewardingProposal = (
  action: BulkApprovalAction,
  data: ApprovalWidgetData[],
): Promise<
  {
    uid: string;
    category: BulkApprovalCategory;
    status: string;
  }[]
> => {
  return fetchFromNewApi(`/rewarding/proposals/${action}`, {
    method: 'POST',
    mode: 'cors',
    cache: 'default',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      proposals: data.map((d) => ({
        uid: d.uid,
        category: d.category,
      })),
    }),
  })
    .then((r) => r.json())
    .then((r) => r.proposals);
};
